<template>
    <div>
        <div class="modal is-active" >
            <div class="modal-background" ></div>
            <div class="modal-content">
                <agile
                    ref="carousel"
                    :autoplay="false"
                    :initialSlide="initialSlide"
                    :dots="false" 
                    :infinite="false"
                    :centerMode="true"
                    class="limited-height"
                    >
                    <div class="slide" v-for="object in objects" :key="object._id">
                        <TreasurehuntPreviewObject
                        :object="object"
                        :tileProvider="tileProvider"
                        />
                    </div>
                    <template slot="prevButton">
                        <span class="icon is-large navButton">
                            <i class="mdi mdi-48px mdi-arrow-left extra-large"></i>
                        </span>
                    </template>
                    <template slot="nextButton">
                        <span class="icon is-large navButton">
                            <i class="mdi mdi-48px mdi-arrow-right extra-large"></i>
                        </span>
                    </template>
                </agile>
            </div>
            <button class="close-preview" aria-label="close" @click="$emit('close')">
                <span class="icon is-large navButton">
                    <i class="mdi mdi-48px mdi-close-circle-outline extra-large"></i>
                </span>
            </button>
            
        </div>
        
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import _ from 'underscore';
import TreasurehuntPreviewObject from '@/components/TreasurehuntPreviewObject';
export default {
    components: {
        agile: VueAgile,
        TreasurehuntPreviewObject
    },
    props: {
        objects: { type: Object, default: {} },
        startInObject: {type: String,default: ''},
        tileProvider: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data: function () {
        return {};
    },
    computed: {
        content() {
            return this.objects;
        },
        initialSlide(){
            if(this.startInObject){
                let arr = Object.entries(this.objects);
            return arr.findIndex(e => e[0] === this.startInObject);
            }else{
                return 0;
            }
            
        }
        
    },
    mounted: function () {
        // console.log("in mounted treasurehunt preview")
        // console.log(this.content,this.initialSlide)
    },
    methods: {
        
    },
};
</script>

<style scoped>
.modal-card-title {
    flex-shrink: 1;
}
.modal-card-body > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.modal-content {
    width: 100%;
    padding: 20px;
    overflow: auto;
}
.lb-modal-comments {
    max-height: 90vh;
}
.lb-card-comments {
    margin: auto;
}
.is-long-title {
    flex-grow: 1;
    width: 0;
}
.is-centered {
    margin: 0 auto;
}
.has-limited-width-600 {
    max-width: 600px;
}

.modal-close.is-large.big{
    height: 64px;
    max-height: 64px;
    max-width: 64px;
    min-height: 64px;
    min-width: 64px;
    width: 64px;
    right: 30px;
    top: 30px;
}

.navButton{
    color:white;
    cursor: pointer;
    height: 64px;
    max-height: 64px;
    max-width: 64px;
    min-height: 64px;
    min-width: 64px;
    width: 64px;
}
.navButton:hover{
    border: none;
    border-radius: 9999px;
    background-color: rgba(74, 74, 74, 0.2);
}
::v-deep .agile__actions{
    position: absolute;
    top:calc(100vh - 50vh - 64px);
    width: calc(100% - 100px);
    left: 50px;
    right: 50px;
}

::v-deep #images-gallery .agile__actions{
    position: unset;
    top:calc(100vh - 50vh - 64px);
    width: calc(100% - 100px);
    left: 50px;
    right: 50px;
}

.mdi-48px.extra-large::before{
    font-size: 90px;
}
.close-preview{
    outline: none;
    border: none;
    position: absolute;
    right: 50px;
    top: 50px;
}
.limited-height{
    height: calc(100vh - 100px);
    max-height: calc(100vh -100px);
}
</style>
